import { Column } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import React from 'react'
import DisabledOverlay from '../../../../../internal/DisabledOverlay'
import Frame from '../../shared/Frame'

const NumberedStep = ({
  number,
  enabled,
  children,
  heading,
  text,
  ...props
}) => (
  <Frame {...props}>
    <DisabledOverlay disable={!enabled}>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Column col1 noPadding>
          <h3 style={{ margin: 0 }}>{number}</h3>
        </Column>
        <Column col11 noPadding>
          <Conditional when={!!heading}>
            <h6 style={{ margin: 0, color: '#050505', fontSize: '1.3em' }}>
              {heading}
            </h6>
          </Conditional>
          <Conditional when={!!text}>
            <p
              style={{
                paddingTop: '0.3rem',
                marginTop: '0',
                marginBottom: '1rem',
                color: '#333',
                userSelect: 'none',
              }}
            >
              {text}
            </p>
          </Conditional>
          {children}
        </Column>
      </div>
    </DisabledOverlay>
  </Frame>
)

export default NumberedStep
